import { InterestedInGender } from 'Store/profile/user.types';

import {
  INTERESTED_IN_BEYOND_BINARY_KEY,
  INTERESTED_IN_MEN_KEY,
  INTERESTED_IN_WOMEN_KEY,
} from 'Components/AllInclusive/constants';
import { InterestedInGenderIntlId } from 'Components/AllInclusive/types';
import { ButtonGroupItem } from 'Components/ButtonGroup/type';
import { CheckboxItem } from 'Components/CheckboxCardForm/CheckboxCardForm';

export const convertToAllInShowMeButtonGroupItems = (
  checkboxes?: CheckboxItem<InterestedInGenderIntlId>[]
): ButtonGroupItem<InterestedInGenderIntlId>[] => {
  if (!checkboxes) return [];
  return checkboxes.map((item) => ({ data: item.itemValue, id: item.itemValue }));
};

const STATES = {
  INITIAL: 'INITIAL',
  MALE: 'MALE',
  MALE_WOMEN: 'MALE_WOMEN',
  MALE_BB: 'MALE_BB',
  WOMEN: 'WOMEN',
  WOMEN_BB: 'WOMEN_BB',
  BEYOND_BINARY: 'BEYOND_BINARY',
  EVERYONE: 'EVERYONE',
} as const;

type StateKeys = keyof typeof STATES;
type State = (typeof STATES)[StateKeys];

const INTERESTED_IN_VALUES_STATE_MACHINE = {
  [STATES.INITIAL]: {
    [INTERESTED_IN_MEN_KEY]: STATES.MALE,
    [INTERESTED_IN_WOMEN_KEY]: STATES.WOMEN,
    [INTERESTED_IN_BEYOND_BINARY_KEY]: STATES.BEYOND_BINARY,
  },
  [STATES.MALE]: {
    [INTERESTED_IN_WOMEN_KEY]: STATES.MALE_WOMEN,
    [INTERESTED_IN_BEYOND_BINARY_KEY]: STATES.MALE_BB,
  },
  [STATES.MALE_WOMEN]: {
    [INTERESTED_IN_BEYOND_BINARY_KEY]: STATES.EVERYONE,
  },
  [STATES.MALE_BB]: {
    [INTERESTED_IN_WOMEN_KEY]: STATES.EVERYONE,
  },
  [STATES.WOMEN]: {
    [INTERESTED_IN_MEN_KEY]: STATES.MALE_WOMEN,
    [INTERESTED_IN_BEYOND_BINARY_KEY]: STATES.WOMEN_BB,
  },
  [STATES.WOMEN_BB]: {
    [INTERESTED_IN_MEN_KEY]: STATES.EVERYONE,
  },
  [STATES.BEYOND_BINARY]: {
    [INTERESTED_IN_MEN_KEY]: STATES.MALE_BB,
    [INTERESTED_IN_WOMEN_KEY]: STATES.WOMEN_BB,
  },
};

export const INTERESTED_IN_EVENT_VALUE: Record<State, number> = {
  [STATES.INITIAL]: -10,
  [STATES.EVERYONE]: -1,
  [STATES.MALE]: INTERESTED_IN_MEN_KEY,
  [STATES.WOMEN]: INTERESTED_IN_WOMEN_KEY,
  [STATES.BEYOND_BINARY]: INTERESTED_IN_BEYOND_BINARY_KEY,
  [STATES.MALE_WOMEN]: 3,
  [STATES.MALE_BB]: 4,
  [STATES.WOMEN_BB]: 5,
};

export const mapEventValueForAllInInterestedIn = (
  interestedInGenderIntl: (InterestedInGender | undefined)[] = []
): number => {
  let CURRENT_STATE: State = STATES.INITIAL;
  interestedInGenderIntl?.forEach((gender) => {
    CURRENT_STATE = INTERESTED_IN_VALUES_STATE_MACHINE[CURRENT_STATE][gender];
  });
  return INTERESTED_IN_EVENT_VALUE[CURRENT_STATE];
};
